import { Flavor } from '@pflegia/types/common/enums/flavor.enum';

export { Flavor };

const DOMAIN_PATTERNS = {
  [Flavor.Pflegia]: [/(^|\.)pflegia\.de$/i, /^.*-pflegia[.-].*\.vercel\.app$/i],
  [Flavor.Praxia]: [/(^|\.)praxia\.de$/i, /^.*-praxia[.-].*\.vercel\.app$/i],
} as const;

export const getFlavorFromDomain = (domain?: string): Flavor => {
  if (!domain) return Flavor.Pflegia;

  // Strip port number if present
  const [cleanDomain] = domain.split(':');
  const lowerDomain = cleanDomain.toLowerCase();

  if (DOMAIN_PATTERNS[Flavor.Praxia].some(pattern => pattern.test(lowerDomain))) {
    return Flavor.Praxia;
  }
  if (DOMAIN_PATTERNS[Flavor.Pflegia].some(pattern => pattern.test(lowerDomain))) {
    return Flavor.Pflegia;
  }
  return Flavor.Pflegia;
};

export const getFlavorFromHost = (host?: string): Flavor => getFlavorFromDomain(host);
